import { apiGet } from 'APIPackage/MainModule/common/apiTools';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';

import { IKnmPlanType } from '../interfaces/IKnmPlanType';

export async function fetchKnmPlanTypes(): Promise<IKnmPlanType[]> {
  return apiGet<IKnmPlanType[]>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/knm-plan-types`);
}
